/**
 * Shared constants and utilities for barcode set handling
 * Used by both Analysis and Run Design
 */

import { Dataset } from "../../model/dataset-model"

export const DEMUX_BARCODES_ENTRY_POINT_ID = "eid_barcode"

export const BARCODE_TYPE = {
    SYMMETRIC: "symmetric",
    ASYMMETRIC: "asymmetric"
} as const

export const SYMMETRIC_BARCODES_TASK_OPTION = "lima_symmetric_barcodes"

/**
 * Check if a barcode set is symmetric based on barcodeType field
 * Returns true for "symmetric", false for "asymmetric", or null if the value should be ignored
 */
export const isBarcodeSetSymmetric = (dataset: Dataset | null | undefined): boolean | null => {
    if (!dataset || !dataset.barcodeType) {
        return null
    }
    
    const barcodeType = dataset.barcodeType.toLowerCase()
    if (barcodeType === BARCODE_TYPE.SYMMETRIC) {
        return true
    } else if (barcodeType === BARCODE_TYPE.ASYMMETRIC) {
        return false
    }
    
    // Other values are ignored
    return null
}

